module.exports = __webpack_public_path__ + "img/Speaker=Caris Frazier-Baker.bef5a632.png";